import Model from './EPGModel';
import View from './EPGView';
import Controller from './EPGController';

// init
const EmbedProgramGuide = (function() {
    return {
        init: () => {
            const model = new Model();
            const view = new View(model);
            const controller = new Controller(model, view);
        }
    }
})()

export default EmbedProgramGuide;
